export function resolveCartId(search: string, storedCartId: string | null) {
  const cartIdFromUrl = new URLSearchParams(search).get("cart_id")?.trim();
  return cartIdFromUrl || storedCartId || null;
}

export function buildCheckoutHref(cartId: string | null) {
  if (!cartId) {
    return "/checkout";
  }

  return `/checkout?cart_id=${encodeURIComponent(cartId)}`;
}
